import { Fragment, useEffect, useRef, useState } from "react";
import { useTypedSelector } from "./../../../hooks/redux-hooks/useTypedSelector";
import { useActions } from "./../../../hooks/redux-hooks/useActions";
import Alert from "./../../../components/Alert/Alert.component";
import { errorHandler } from "./../../../helpers/errorHandler";
import WalletModalStepOne from "./WalletModalStepOne/WalletModalStepOne.component";
import { WalletModalStepTwo } from "./WalletModalStepTwo/WalletModalStepTwo.component";
import { selectWalletTopUpCurrentStep } from "../../../redux/selectors/walletTopUpSelector";
import { appInsights } from "../../../components/AppInsight/AppInsight";

export default function WalletModal() {
  const dismissRef = useRef<null | HTMLButtonElement>(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const currentStep = useTypedSelector(selectWalletTopUpCurrentStep);
  const { resetWithdrawal } = useActions();

  const closeModal = () => {
    dismissRef?.current?.click();
    resetWithdrawal();
  };

  useEffect(() => {
    appInsights.trackPageView({
      name: "WalletModal.component.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <Fragment>
      {error && (
        <Alert
          message={
            errorHandler(error) ||
            "An error occured while processing your withdrawal, please try again."
          }
        />
      )}
      {success && <Alert message={success} type="success" />}
      <div
        className="modal fade"
        id="walletModal"
        tabIndex={-1}
        aria-labelledby="walletModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content p-2">
            <div className="modal-body">
              <button
                type="button"
                className="d-none"
                data-dismiss="modal"
                aria-label="Close"
                ref={dismissRef}
              >
                <span aria-hidden="true">&times;</span>
              </button>

              {(() => {
                switch (currentStep) {
                  case 1:
                    return (
                      <WalletModalStepOne
                        closeModal={closeModal}
                        setError={setError}
                        setSuccess={setSuccess}
                      />
                    );
                  case 2:
                    return (
                      <WalletModalStepTwo
                        closeModal={closeModal}
                        setError={setError}
                        setSuccess={setSuccess}
                        error={error}
                        success={success}
                      />
                    );
                  default:
                    return null;
                }
              })()}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
